import React, { useState, useEffect, useContext, useRef } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Input,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  Table,
} from "reactstrap";
import DataTable from "react-data-table-component";
import { useDispatch, useSelector } from "react-redux";
import { ThemeContext } from "../contexts/ThemeContext.js";
import { fetchTransactions } from "../redux/actions/transactionActions.js";

const TransactionList = () => {
  const { theme } = useContext(ThemeContext);
  const dispatch = useDispatch();
  const isFirstRender = useRef(true);

  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [searchTerm, setSearchTerm] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedVouchers, setSelectedVouchers] = useState([]);

  const { transactions, loading } = useSelector((state) => state.transactionList);

  // Data + Pagination values
  const transactionData = transactions?.data || [];
  const totalItems = transactions?.pagination?.totalItems || 0;

  // Table Columns
  const columns = [
    { name: <b>S.No</b>, cell: (row, index) => index + 1 + (currentPage - 1) * itemsPerPage },
    { name: <b>Transaction ID</b>, selector: (row) => row?.txnid, wrap: true, width: "200px" },
    { name: <b>Amount</b>, selector: (row) => `Rs.${row?.amount}` },
    { name: <b>Order Status</b>, selector: (row) => row?.status },
    { name: <b>Order Date</b>, selector: (row) => new Date(row?.createdAt).toLocaleDateString("en-GB") },
    { name: <b>Buyer Name</b>, selector: (row) => row?.user_id?.name },
    { name: <b>Buyer Number</b>, selector: (row) => row?.user_id?.mobilenumber },
    { name: <b>Whatsapp Number</b>, selector: (row) => row?.user_id?.whatsappnumber },
    { name: <b>Buyer Email</b>, selector: (row) => row?.user_id?.email, wrap: true, width: "200px" },
    {
      name: <b>Vouchers</b>,
      cell: (row) => (
        <Button
          color="info"
          size="sm"
          onClick={() => {
            setSelectedVouchers(row?.vouchers || []);
            setModalOpen(true);
          }}
        >
          View
        </Button>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
    {
      name: <b>Actions</b>,
      cell: (row) =>
        row?.status !== "success" && (
          <Button color="primary" size="sm" onClick={() => handleRecheck(row)}>
            Recheck
          </Button>
        ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
  ];

  const handleRecheck = (row) => {
    console.log("Rechecking transaction:", row);
  };

  useEffect(() => {
    dispatch(fetchTransactions(currentPage, itemsPerPage, searchTerm));
  }, [dispatch, currentPage, itemsPerPage, searchTerm]);

  return (
    <Container fluid>
      <Row className="mb-3">
        <Col sm="6">
          <h4>Transaction List</h4>
        </Col>
        <Col sm="6" className="text-right">
          <Input
            type="text"
            placeholder="Search by Transaction ID"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </Col>
      </Row>

      <Card>
        <CardBody>
          <DataTable
            columns={columns}
            data={transactionData}
            progressPending={loading}
            theme={theme === "dark" ? "darkMode" : "lightMode"}
            pagination
            paginationServer
            paginationTotalRows={totalItems}
            paginationPerPage={itemsPerPage}
            onChangePage={(page) => setCurrentPage(page)}
          />
        </CardBody>
      </Card>

      {/* Modal for Voucher Details */}
      <Modal isOpen={modalOpen} toggle={() => setModalOpen(!modalOpen)} size="lg">
        <ModalHeader toggle={() => setModalOpen(!modalOpen)}>Voucher Details</ModalHeader>
        <ModalBody>
          <div className="table-responsive">
            <Table bordered>
              <thead>
                <tr>
                  <th>#</th>
                  <th>Voucher ID</th>
                  <th>Brand Name</th>
                  <th>Sold Price</th>
                  <th>Expire Date</th>
                  <th>Actual Price</th>
                  <th>Seller Name</th>
                  <th>Seller Mobile</th>
                  <th>Seller Email</th>
                </tr>
              </thead>
              <tbody>
                {selectedVouchers.map((voucher, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{voucher?.voucherId?.voucherId || "N/A"}</td>
                    <td>{voucher?.voucherId?.brandId?.brandName || "N/A"}</td>
                    <td>Rs.{voucher?.acceptedPrice || "N/A"}</td>
                    <td>
                      {voucher?.voucherId?.expireDate
                        ? new Date(voucher?.voucherId?.expireDate).toLocaleDateString("en-GB")
                        : "N/A"}
                    </td>
                    <td>Rs.{voucher?.voucherId?.actualPrice || "N/A"}</td>
                    <td>{voucher?.voucherId?.userId?.name || "N/A"}</td>
                    <td>{voucher?.voucherId?.userId?.mobilenumber || "N/A"}</td>
                    <td>{voucher?.voucherId?.userId?.email || "N/A"}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        </ModalBody>
      </Modal>
    </Container>
  );
};

export default TransactionList;
